import { File } from '../file';
import { ContentIntro } from './intro';

/**
 * Model definition for Images-Decorative
 */
export interface ContentImagesDecorative {
  __component: 'content.images-decorative';
  id: string;
  intro?: ContentIntro;
  media: File[];
  size: 'wide' | 'text';
}

export function isContentImagesDecorative(obj: { __component?: string }): obj is ContentImagesDecorative {
  return obj.__component === 'content.images-decorative';
}
